/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Toast_Pages_UpgradedInputs */



/**
* | output |
* | --- |
* | "Pages add-on upgraded." |
*
* @param {Sub_Addons_Toast_Pages_UpgradedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_toast_pages_upgraded = /** @type {((inputs?: Sub_Addons_Toast_Pages_UpgradedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Toast_Pages_UpgradedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Seiten-Add-on hochgestuft.")
	return /** @type {LocalizedString} */ ("Pages add-on upgraded.")
});